import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { RippleModule } from 'primeng/ripple';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { UserStateService } from '@/app/features/user/services';

@Component({
  selector: '[app-profile]',
  standalone: true,
  imports: [CommonModule, RippleModule, ConfirmDialogModule],
  providers: [ConfirmationService],
  template: `
    <button
      id="profile-nav-btn"
      pRipple
      [class]="buttonClass"
      (click)="navigateToProfile()"
    >
      <i class="pi pi-user"></i>
      <span>Mi Perfil</span>
    </button>
    <button
      id="billing-nav-btn"
      pRipple
      [class]="buttonClass"
      (click)="navigateToBilling()"
    >
      <i class="pi pi-credit-card"></i>
      <span>Suscripción</span>
    </button>
    <button
      id="profile-logout-btn"
      pRipple
      [class]="buttonClass"
      (click)="logout()"
    >
      <i class="pi pi-sign-out"></i>
      <span>Cerrar Sesión</span>
    </button>

    <p-confirmDialog
      header="Confirmar Cierre de Sesión"
      acceptLabel="Sí, cerrar sesión"
      rejectLabel="No, cancelar"
      acceptButtonStyleClass="p-button-danger"
      rejectButtonStyleClass="p-button-text"
      [closable]="!userStateService.logoutLoading()"
    />
  `,
  host: {
    class:
      'z-30 p-2 space-y-2 rounded-2xl bg-surface-0 dark:bg-surface-950 shadow-[0px_129.205px_36.493px_0px_rgba(44,54,87,0.00),_0px_82.849px_33.534px_0px_rgba(44,54,87,0.01),_0px_46.356px_27.616px_0px_rgba(44,54,87,0.03),_0px_20.712px_20.712px_0px_rgba(44,54,87,0.05),_0px_4.932px_11.836px_0px_rgba(44,54,87,0.06)] dark:shadow-stroke',
  },
})
export class AppProfile {
  readonly userStateService = inject(UserStateService);
  private readonly router = inject(Router);
  private readonly confirmationService = inject(ConfirmationService);

  readonly userName = computed(() => {
    const data = this.userStateService.userData();
    return data?.firstName || 'Usuario';
  });

  readonly userInitial = computed(() =>
    this.userName().charAt(0).toUpperCase(),
  );

  readonly buttonClass =
    'w-full px-3 py-2 rounded-lg flex items-center gap-2 font-medium text-surface-500 hover:text-surface-950 dark:hover:text-surface-0 hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150';

  navigateToProfile(): void {
    this.router.navigate(['/profile']);
  }

  navigateToBilling(): void {
    this.router.navigate(['/billing']);
  }

  logout(): void {
    this.confirmationService.confirm({
      message: '¿Estás seguro de que quieres cerrar sesión?',
      accept: () => this.userStateService.logout(),
    });
  }
}
